import { Guid, IBaseModel, TNikanDate } from '~/interfaces/base'
import emptyId from '@/statics/empty-id'

export class SalaryPeriod implements IBaseModel {
	id: Guid
	fiscalPeriodId: Guid
	date!: string
	isLocked: boolean
	isMain: boolean
	displayName: string
	canUse: boolean

	constructor(id: Guid = emptyId, fiscalPeriodId: Guid = emptyId, date: TNikanDate | string = '', isLocked: boolean = false, isMain: boolean = false, displayName: string = '', canUse: boolean = false) {
		this.id = id
		this.fiscalPeriodId = fiscalPeriodId
		this.date = date
		this.isLocked = isLocked
		this.isMain = isMain
		this.displayName = displayName
		this.canUse = canUse
	}
}

export class SubPeriod extends SalaryPeriod {
	selected: boolean = false
}

export class SelectedPastPeriod extends SubPeriod {
	name: string | null = null
}

export class ConvertedSalaryPeriod {
	pMonthName!: string
	pYear!: string
	pMonth!: string
	date!: string
	canUse!: boolean
	year!: string
	month!: string
	subPeriods: SubPeriod[] = []
	filteredSubPeriods: SubPeriod[] = []
}

export class CreateMonth extends ConvertedSalaryPeriod {
	name: string | null = null
}

export class CreatePeriodOptions {
	months: ConvertedSalaryPeriod[] = [new ConvertedSalaryPeriod()]
	subPeriod = new SubPeriod()
	selectedMonth = new ConvertedSalaryPeriod()
	getMonths() {

	}
}

export class CreatePeriodType {
	isMain = false
	name!: string
}

export class CreatePeriodValue {
	selectedMonth = new CreateMonth()
	selectedType = new CreatePeriodType()
	selectedPastMonth = new ConvertedSalaryPeriod()
	selectedPastDisplayName = new SelectedPastPeriod()
	displayName!: string | null
	tableCopy = false
	contractCopy = false
	salaryItemCopy = false
	copySettings = false
}

export class MonthPeriodCardOptions {
	title!: string
	period = new ConvertedSalaryPeriod()

	insertPeriodFunc(subPeriod: SubPeriod): void { }
}

export interface IStringMap<T = string> {
	[key: string]: T
}